export default {"src":"/_next/static/media/calcIcon.2feee603.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};